import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import Button from '../Button';

const ShareMobile = ({ copy, title }) => {
    const handleShare = () => {
        if (navigator.canShare) {
            navigator
                .share({
                    text: copy,
                    title
                })
                .catch(error => {
                    // eslint-disable-next-line no-console
                    console.log('Error while attempting to share', error);
                });
        }
    };

    return (
        <Styled.ShareMobileWrapper>
            <Styled.ShareMobileButtonWrapper>
                <Button
                    type="secondary"
                    buttonText="SHARE NOW"
                    onClick={handleShare}
                    disabled={false}
                />
            </Styled.ShareMobileButtonWrapper>
        </Styled.ShareMobileWrapper>
    );
};

ShareMobile.defaultProps = {
    copy: null,
    title: null
};

ShareMobile.propTypes = {
    copy: PropTypes.string,
    title: PropTypes.string
};

export default ShareMobile;
